import { ChangeDetectionStrategy, Component, output, ViewEncapsulation } from '@angular/core';
import { getIconClassByObjectType } from '@fi-shared/utils/get-icon-class-by-object-type';
import { getObjectTypeNameTextId } from '@fi-shared/utils/object-type-name';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { ObjectTypes } from '@fi-app/shared/types/object-type';

@Component({
    selector: 'fi-element-object-type-picker-slide',
    templateUrl: './element-object-type-picker-slide.component.html',
    styleUrls: ['./element-object-type-picker-slide.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'element-object-type-picker-slide' },
    standalone: false,
})
export class FiElementObjectTypePickerSlideComponent {
    selectElementObjectType = output<ObjectTypes>();

    protected readonly FiInfoIconMode = FiInfoIconMode;
    protected getIconClassByObjectType = getIconClassByObjectType;
    protected getObjectTypeNameTextId = getObjectTypeNameTextId;
    protected elementObjectTypes: ReadonlyArray<ObjectTypes> = [
        ObjectTypes.Document,
        ObjectTypes.MediaBank,
        ObjectTypes.Quiz,
        ObjectTypes.TodoList,
    ];
}
